import axiosTokenInstance from 'services/api/backoffice';
import { DIRECTORY_STORES_OMVS, DIRECTORY_STORES_OMVS_ERROR } from '_models/redux/types';

// Acción para verificar si una tienda existe
export const directoryStoresOmvsAction = (validation) => async (dispatch) => {
  console.log('params (FormData)', validation);

  try {
    const response = await axiosTokenInstance.get(`/api/ipb/directory-stores/omvs`);

    const { data, status } = response || {};

    // Despachar los datos de la respuesta
    dispatch({
      type: DIRECTORY_STORES_OMVS,
      payload: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    // Manejo de errores
    dispatch({
      type: DIRECTORY_STORES_OMVS_ERROR,
      payload: e || {},
    });
  }
};
